import { useQuery } from '@tanstack/react-query';
import { COMPLIANCE_TIMEOUT_MS, runComplianceRequest } from 'src/api/complianceRequest';
import { HandshakePainterServiceApiV1 } from 'src/api/handshakeApi';
import { useAnalyticsContext } from 'src/common/metrics';
import { useDefaultApiParams } from './useDefaultApiParams';
/**
 * Fetches detail compliance data for a given ASIN.
 *
 * Uses `staleTime: Infinity` so that once data is fetched it is served from
 * cache on subsequent renders without triggering a network call. The cache is
 * cleared on route changes via `App.tsx`.
 *
 * Gate `enabled` on user interaction (e.g. sidesheet open) to defer the first
 * fetch until the data is actually needed.
 */
export const useProductComplianceDetailContent = ({ asin, enabled = true }) => {
    const defaultApiParams = useDefaultApiParams().getDefaultParams();
    const rumClient = useAnalyticsContext();
    return useQuery({
        queryKey: ['getProductComplianceDetail', asin],
        queryFn: ({ signal }) => runComplianceRequest({
            eventPrefix: 'COMPLIANCE_DETAIL_CONTENT',
            asin,
            timeoutMs: COMPLIANCE_TIMEOUT_MS.DETAIL_CONTENT,
            querySignal: signal,
            rumClient,
            request: (requestSignal) => HandshakePainterServiceApiV1.getProductComplianceDetail({
                asin: asin,
                xUserLinked: defaultApiParams.xUserLinked,
                xJoinId: defaultApiParams.xJoinId,
                marketplaceId: defaultApiParams.marketplaceId,
            }, { signal: requestSignal }),
        }),
        enabled: enabled && !!asin,
        staleTime: Infinity,
    });
};
